let utils = {};

utils.sortAndPlaceOthersAtEnd = (data) => {
  if (!Array.isArray(data)) return [];
  const others = data.filter((item) => item?.name === "Others");
  const rest = data.filter((item) => item?.name !== "Others");
  rest.sort((a, b) => b.y - a.y);

  return [...rest, ...others];
};

utils.monthLabelToKey = (label = "") => {
  if (!label) return "";

  // Handles: "January 2025", "Jan'25", "Feb 25"
  const cleaned = label.replace("'", " ");
  const parts = cleaned.split(" ");

  const month = parts[0];
  const year = parts[1] || "";

  return `${month.slice(0, 3).toLowerCase()}${year}`;
};

utils.getMonthsFromData = (monthWise = []) =>
  monthWise.map((m) => ({
    key: utils.monthLabelToKey(m.month),
    label: m.month,
  }));

// utils.transformInvestmentData = (apiData = {}) => {
//   const { overall = {}, monthWise = [] } = apiData;

//   const months = utils.getMonthsFromData(monthWise).slice(-6);

//   // map months for O(1) lookup
//   const monthMap = {};
//   monthWise.forEach((m) => {
//     monthMap[utils.monthLabelToKey(m.month)] = m;
//   });

//   const rows = [
//     { particular: "Total Calls", total: overall.totalCalls },
//     { particular: "Total Invested", total: overall.avgAmountInvested },
//     { particular: "Open Calls", total: overall.openCalls },
//     { particular: "Closed Calls", total: overall.closedCalls },
//     {
//       particular: "Open Calls Returns",
//       total: `${overall.openCallReturns}%`,
//     },
//     {
//       particular: "Closed Calls Returns",
//       total: `${overall.closedCallReturns}%`,
//     },
//     {
//       particular: "NIFTY Returns",
//       total:
//         overall.niftyReturns === null || overall.niftyReturns === undefined
//           ? "NA"
//           : `${overall.niftyReturns}%`,
//     },

//     { particular: "Holding Days", total: overall.avgHoldingDays },
//     { particular: "Total Returns", total: overall.totalReturns },
//   ];

//   rows.forEach((row) => {
//     months.forEach(({ key }) => {
//       const m = monthMap[key];
//       if (!m) {
//         row[key] = "-";
//         return;
//       }

//       switch (row.particular) {
//         case "Total Calls":
//           row[key] = m.totalCalls;
//           break;
//         case "Total Invested":
//           row[key] = m.avgAmountInvested;
//           break;
//         case "Open Calls":
//           row[key] = m.openCalls;
//           break;
//         case "Closed Calls":
//           row[key] = m.closedCalls;
//           break;
//         case "Open Calls Returns":
//           row[key] = `${m.openCallReturns}%`;
//           break;
//         case "Closed Calls Returns":
//           row[key] = `${m.closedCallReturns}%`;
//           break;
//         case "NIFTY Returns":
//           row[key] =
//             m.niftyReturns === null || m.niftyReturns === undefined
//               ? "NA"
//               : `${m.niftyReturns}%`;
//           break;
//         case "Holding Days":
//           row[key] = m.avgHoldingDays;
//           break;
//         case "Total Returns":
//           row[key] = m.totalReturns;
//           break;
//         default:
//           row[key] = "-";
//       }
//     });
//   });

//   return { rows, months };
// };

utils.transformInvestmentData = (apiData = {}) => {
  const { overall = {}, monthWise = [] } = apiData;

  if (
    (!overall || Object.keys(overall).length === 0) &&
    (!Array.isArray(monthWise) || monthWise.length === 0)
  ) {
    return { rows: [], months: [] };
  }

  const months = utils.getMonthsFromData(monthWise).slice(-6);

  const monthMap = {};
  monthWise.forEach((m) => {
    monthMap[utils.monthLabelToKey(m.month)] = m;
  });

  const rows = [
    { particular: "Total Calls", total: overall.totalCalls },
    { particular: "Total Invested", total: overall.avgAmountInvested },
    { particular: "Open Calls", total: overall.openCalls },
    { particular: "Closed Calls", total: overall.closedCalls },
    {
      particular: "Open Calls Returns",
      total: `${overall.pl}%`,
    },
    {
      particular: "Closed Calls Returns",
      total: `${overall.closedCallReturns}%`,
    },
    {
      particular: "NIFTY Returns",
      total:
        overall.niftyReturns === null || overall.niftyReturns === undefined
          ? "-"
          : `${overall.niftyReturns}%`,
    },
    { particular: "Holding Days", total: overall.avgHoldingDays },
    { particular: "Total Returns", total: overall.totalReturns },
  ];

  // 👉 ADD P&L ROW AT THE END
  const plRow = {
    particular: "P & L",
    total:
      overall.pl === null || overall.pl === undefined
        ? "NA"
        : `${overall.pl}%`,
  };

  // fill month columns with blank / "-"
  months.forEach(({ key }) => {
    plRow[key] = "-";
  });

  rows.push(plRow);

  // populate month-wise values for other rows
  rows.forEach((row) => {
    months.forEach(({ key }) => {
      const m = monthMap[key];
      if (!m || row.particular === "P & L") {
        row[key] = row[key] ?? "-";
        return;
      }

      switch (row.particular) {
        case "Total Calls":
          row[key] = m.totalCalls;
          break;
        case "Total Invested":
          row[key] = m.avgAmountInvested;
          break;
        case "Open Calls":
          row[key] = m.openCalls;
          break;
        case "Closed Calls":
          row[key] = m.closedCalls;
          break;
        case "Open Calls Returns":
          row[key] = `${m.openCallReturns}%`;
          break;
        case "Closed Calls Returns":
          row[key] = `${m.closedCallReturns}%`;
          break;
        case "NIFTY Returns":
          row[key] =
            m.niftyReturns === null || m.niftyReturns === undefined
              ? "-"
              : `${m.niftyReturns}%`;
          break;
        case "Holding Days":
          row[key] = m.avgHoldingDays;
          break;
        case "Total Returns":
          row[key] = m.totalReturns;
          break;
        default:
          row[key] = "-";
      }
    });
  });

  return { rows, months };
};


utils.formatMetrics = (metrics = {}) => {
  if (!metrics || typeof metrics !== "object") return [];
  if (Object.keys(metrics).length === 0) return [];

  const LABEL_OVERRIDES = {
    sharp_ratio: "Sharpe Ratio",
    sharpe_ratio: "Sharpe Ratio",
    calmar_ration: "Calmar Ratio",
    calmar_ratio: "Calmar Ratio",
    sortino_ratio: "Sortino Ratio",
    annual_volatility: "Annual Volatility",
    daily_risk: "Daily Value at Risk",
    daily_value_at_risk: "Daily Value at Risk",
  };

  return Object.entries(metrics).map(([key, metric]) => {
    const label =
      LABEL_OVERRIDES[key] ||
      key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

    const rawValue = metric?.value;

    const formattedValue = key.includes("volatility")
      ? rawValue !== null && rawValue !== undefined
        ? `${rawValue}%`
        : "-"
      : rawValue?.toString() ?? "-";

    return {
      key,
      label,
      value: formattedValue,
      threshold: metric?.threshold || null,
      tooltip: metric?.tooltip || null,
    };
  });
};



utils.formatChartData = (dataObj) => {
  if (!dataObj || typeof dataObj !== "object") return [];
  if (Object.keys(dataObj).length === 0) return []; 

  const formatted = Object.entries(dataObj)
    .map(([key, value]) => ({
      name: key,
      y: Number(value),
      displayValue: value,
    }))
  .filter((item) => !isNaN(item.y)); // safety

  if (formatted.length === 0) return [];

  const others = formatted.filter((item) => item.name === "Others");
  const rest = formatted.filter((item) => item.name !== "Others");

  rest.sort((a, b) => b.y - a.y);

  return [...rest, ...others];
};
utils.formatSectorData = (data) => {
  if (!Array.isArray(data)) return [];

  return data
    .filter((item) => item?.name)
    .map((item) => ({
      name: item.name,
      weightage: item.weightage?.toString() ?? "-",
      return: item.return?.toString() ?? "-",
      contribution: item.contri_to_portfolio?.toString() ?? "-",
    }));
};

utils.ascendungOrder = (data) => {
  if (!Array.isArray(data)) return [];
  return data.sort((a, b) => a.y - b.y);
};

/**
 * Builds table columns based on duration
 */
utils.getColumnsByDuration = ({
  duration,
  allMonths,
  includeParticular = true,
  includeTotal = true,
}) => {
  const count = Number(duration);
  const months = allMonths.slice(-count);

  const columns = [];

  if (includeParticular) {
    columns.push({ field: "particular", headerText: "Particulars" });
  }

  if (includeTotal) {
    columns.push({ field: "total", headerText: "Total" });
  }

  columns.push(
    ...months.map((m) => ({
      field: m.key,
      headerText: m.label,
    }))
  );

  return columns;
};

/**
 * Filters row data based on duration
 */
utils.getDataByDuration = ({ duration, allMonths, data }) => {
  const count = Number(duration);
  const monthKeys = allMonths.slice(-count).map((m) => m.key);

  return data.map((row) => {
    const filteredRow = {};

    // keep all non-month fields
    Object.keys(row).forEach((key) => {
      if (!allMonths.some((m) => m.key === key)) {
        filteredRow[key] = row[key];
      }
    });

    // add only required months
    monthKeys.forEach((key) => {
      filteredRow[key] = row[key];
    });

    return filteredRow;
  });
};

utils.formatPlanFrequency = (frequency = "") => {
  if (!frequency || typeof frequency !== "string") return "";

  return frequency
    .toLowerCase()        // half_yearly
    .split("_")           // ["half", "yearly"]
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    )                     // ["Half", "Yearly"]
    .join("-");            // Half-Yearly
};

export { utils };
